// extracted by mini-css-extract-plugin
module.exports = {"nav__brand":"_navbrand_nav__brand__0MIDl"};